export const navItems = [
  {
    id: 1,
    title: "Mobile Repairs",
    path: "./services",
    cName: "nav-item",
    dropdown: [
      {
        id: 1,
        title: "Screen Repair",
        path: "./screen-repair",
        cName: "submenu-item",
      },
      {
        id: 2,
        title: "Battery Replacement",
        path: "./battery-replacement",
        cName: "submenu-item",
      },
      {
        id: 3,
        title: "Water Damage Repair",
        path: "./water-damage-repair",
        cName: "submenu-item",
      },
      {
        id: 4,
        title: "Software Issues",
        path: "./software-issues",
        cName: "submenu-item",
      },
    ],
  },
  {
    id: 2,
    title: "Apple Watch Repair",
    path: "./products",
    cName: "nav-item",
    dropdown: [
      {
        id: 1,
        title: "Screen Repair",
        path: "./apple-watch-screen-repair",
        cName: "submenu-item",
      },
      {
        id: 2,
        title: "Battery Replacement",
        path: "./apple-watch-battery-replacement",
        cName: "submenu-item",
      },
    ],
  },
  {
    id: 3,
    title: "Ipad Repairs",
    path: "./products",
    cName: "nav-item",
    dropdown: [
      {
        id: 1,
        title: "Screen Repair",
        path: "./ipad-screen-repair",
        cName: "submenu-item",
      },
      {
        id: 2,
        title: "Battery Replacement",
        path: "./ipad-battery-replacement",
        cName: "submenu-item",
      },
    ],
  },
  {
    id: 4,
    title: "Macbook Repairs",
    path: "./products",
    cName: "nav-item",
    dropdown: [
      {
        id: 1,
        title: "Screen Repair",
        path: "./macbook-screen-repair",
        cName: "submenu-item",
      },
      {
        id: 2,
        title: "Battery Replacement",
        path: "./macbook-battery-replacement",
        cName: "submenu-item",
      },
    ],
  },
  {
    id: 5,
    title: "Accessories",
    path: "./products",
    cName: "nav-item",
    dropdown: [
      {
        id: 1,
        title: "Chargers",
        path: "./chargers",
        cName: "submenu-item",
      },
      {
        id: 2,
        title: "Cables",
        path: "./cables",
        cName: "submenu-item",
      },
    ],
  },
];
